module.exports = __webpack_public_path__ + "assets/img/preview_02.08c6a921.png";